module.exports = __webpack_public_path__ + "img/warning.269169a0.png";